import React, { useState, useEffect } from "react";
import { Row, ToastContainer, Col } from "react-bootstrap";
import Toast from "react-bootstrap/Toast";

const NotificationMessage = (props) => {
  const response = props.response;
  // console.log("Message", props.response);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(response.code === 200 ? true : false);
  }, [response]);

  return (
    <Row>
      <Col>
        {response.code && (
          <ToastContainer position="bottom-end" className="p-3">
            <Toast
              className="d-inline-block m-1"
              bg="primary"
              onClose={() => setShow(!show)}
              show={show}
              delay={3000}
              autohide
            >
              <Toast.Header>
                <strong className="me-auto">Notification</strong>
              </Toast.Header>
              <Toast.Body className="Dark text-white">
                {response.msg}
              </Toast.Body>
            </Toast>
          </ToastContainer>
        )}
      </Col>
    </Row>
  );
};

export default NotificationMessage;
